const marketplaceEn = {
    cropListing: require('../../lang/en/marketplace/CropListing').default,
};

export default marketplaceEn;